"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGUIDv4 = void 0;
/**
 * Determine if the token has the format of a v4 GUID.
 * @param token The value to check.
 */
const isGUIDv4 = (token) => token.length == 36 && !!token.match(/^[a-z0-9-]{14}4[a-z0-9-]{21}$/i);
exports.isGUIDv4 = isGUIDv4;
//# sourceMappingURL=uuid_utils.js.map